export type CitySelectorState = {
    typedText: string
    locationSuggestions: ReadonlyArray<TPlaceSuggestion>
    selectedLocationSuggestion: TPlaceSuggestion | null
    sessionToken: string
    enableLocationSuggestions: boolean
    selectedPlaceId: TPlaceId | null
    selectedIocCode: TIocCode | null
}

export type CitySelectorAction =
    | { type: 'SET_TYPED_TEXT'; payload: string }
    | { type: 'SET_SELECTED_PLACEID'; payload: TPlace }
    | { type: 'CLEAR_STATE' }
    | { type: 'SET_SELECTED_LOCATION_SUGGESTION'; payload: string }
    | { type: 'SET_LOCATION_SUGGESTIONS'; payload: ReadonlyArray<TPlaceSuggestion> }

export const createToken = (): string =>
    Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

export function reducer(prevState: CitySelectorState, action: CitySelectorAction): CitySelectorState {
    switch (action.type) {
        case 'SET_TYPED_TEXT': {
            if (!action.payload) {
                return {
                    ...prevState,
                    typedText: '',
                    locationSuggestions: [],
                    enableLocationSuggestions: false,
                }
            }

            return {
                ...prevState,
                typedText: action.payload,
                enableLocationSuggestions: true,
            }
        }
        case 'CLEAR_STATE': {
            return {
                ...prevState,
                typedText: '',
                locationSuggestions: [],
                selectedLocationSuggestion: null,
                sessionToken: createToken(),
                enableLocationSuggestions: false,
                selectedPlaceId: null,
                selectedIocCode: null,
            }
        }
        case 'SET_SELECTED_LOCATION_SUGGESTION': {
            const selectedLocationSuggestion =
                prevState.locationSuggestions.find((city) => city.placeId === action.payload) ?? null

            return {
                ...prevState,
                selectedLocationSuggestion,
                sessionToken: createToken(),
            }
        }
        case 'SET_LOCATION_SUGGESTIONS': {
            return {
                ...prevState,
                locationSuggestions: action.payload,
            }
        }
        case 'SET_SELECTED_PLACEID': {
            return {
                ...prevState,
                selectedPlaceId: action.payload.placeId,
                selectedIocCode: action.payload.country.iocCode,
            }
        }
        default: {
            return prevState
        }
    }
}
